import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import support from '../utils/BrowserSupport'
import { limit } from '../utils/Number'


const ACTIVE = 'is-active'
const VISIBLE = 'is-visible'

export default class NavLayer extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            blocks: [],
            backLinks: [],
            content: null
        }

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }
        this.isMobile = true

        this._onHide = () => {}
        this._onMouseEnter = () => {}
        this._onMouseLeave = () => {}

    }

    prepare() {
        this.cache = this.ref.blocks.reduce((acc, block) => {
            acc[block.dataset.id] = block
            return acc
        }, {})

        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(ACTIVE)) {
                this.element.classList.remove(VISIBLE)
                this.onAfterHide()
            }
        })

        this.element.addEventListener('click', ::this.handleClick)

        this.ref.backLinks.forEach(element => element.addEventListener('click', ::this.handleBackClick))
        this.ref.content.addEventListener('mouseenter', ::this.handleMouseEnter)
        this.ref.content.addEventListener('mouseleave', ::this.handleMouseLeave)
        enquire.register(queries.xlargeUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.xlargeUp, this.enquireHandler)
    }

    match() {
        this.isMobile = false
    }

    unmatch() {
        this.isMobile = true
        this.ref.content.removeAttribute('style')
    }

    show(blockId, blockPos) {
        if (blockId in this.cache) {
            if (this.isMobile) {
                Object.keys(this.cache)
                    .forEach(key => {
                        this.cache[key].classList.toggle(VISIBLE, key === blockId)
                    })
                this.element.classList.add(VISIBLE)
                this.element.offsetWidth
                this.element.classList.add(ACTIVE)
            } else {
                if (!this.is(VISIBLE)) {
                    this.element.classList.add(VISIBLE)
                    this.element.offsetWidth
                }
                this.element.classList.add(ACTIVE)
                // 68 = size of shadow
                this.element.style.left = blockPos.left - 68 + 'px'

				const headerHasMessage = document.getElementsByClassName('header--has-message');

				if (headerHasMessage.item(0)) {
					const headerContent = document.getElementsByClassName('Header-content').item(0);

					if (headerContent) {
						this.element.style.top = headerContent.offsetHeight + 'px';
					}
				} else {
					this.element.style.top = '40px';
				}

				// console.log(header.item(0).offsetHeight);

                Object.keys(this.cache)
                    .forEach(key => {
                        this.cache[key].classList.toggle(VISIBLE, key === blockId)
                    })

            }
        }
    }

    hide() {
        this.element.classList.remove(ACTIVE)
        // this.element.removeAttribute('style')
        this._onHide()
    }

    isActive() {
        return this.is(ACTIVE)
    }

    onHide(callback) {
        this._onHide = callback
    }

    onAfterHide() {
        this.ref.blocks.forEach(block => block.classList.remove(VISIBLE))
    }

    handleBackClick(event) {
        event.preventDefault()
        this.hide()
    }

    handleClick(event) {
        if (!this.isMobile && event.target === this.element) {
            this.hide()
        }
    }

    onMouseEnter(callback) {
        this._onMouseEnter = callback
    }

    handleMouseEnter() {
        this._onMouseEnter()
    }

    onMouseLeave(callback) {
        this._onMouseLeave = callback
    }

    handleMouseLeave() {
        this._onMouseLeave()
    }

}
